module.exports = __webpack_public_path__ + "fonts/ChiQiang-2.d574c48b.ttf";